const mutations = {
    showErrorPage(state, payload) {
        state.data.errorPage = {
            title: payload.title,
            description: payload.description,
        }

        state.data.showErrorPage = true
    },
    hideErrorPage(state) {
        state.data.errorPage = {}
        state.data.showErrorPage = false
    },
    setGeneralLoaderVisible(state, payload) {
        state.data.showGeneralLoader = payload

        if (payload) {
            document.getElementsByTagName('body')[0].classList.add('general-loader-active')
        } else {
            document.getElementsByTagName('body')[0].classList.remove('general-loader-active')
        }
    },
}

const actions = {
    processErrorHttpStatus(context, statusCode, forceNewError = true) {
        if (statusCode !== 200 && context.errorPageVisible && !forceNewError) {
            return false
        }

        switch (statusCode) {
            case 200:
                context.commit('hideErrorPage')
                return true

            case 404:
                context.commit('showErrorPage', {
                    title: context.state.$t('errors.pages.notFound.heading'),
                    description: context.state.$t('errors.pages.notFound.description'),
                })
                break

            case 403:
                context.commit('showErrorPage', {
                    title: context.state.$t('errors.pages.unauthorized.heading'),
                    description: context.state.$t('errors.pages.unauthorized.description'),
                })
                break

            case 422:
                context.commit('showErrorPage', {
                    title: context.state.$t('errors.pages.unprocessable.heading'),
                    description: context.state.$t('errors.pages.unprocessable.description'),
                })
                break

            case 500:
                context.commit('showErrorPage', {
                    title: context.state.$t('errors.pages.internalError.heading'),
                    description: context.state.$t('errors.pages.internalError.description'),
                })
                break

            default:
                context.commit('showErrorPage', {
                    title: context.state.$t('errors.pages.clientError.heading'),
                    description: context.state.$t('errors.pages.clientError.description'),
                })
                break
        }

        return false
    },
}

const getters = {
    loanPurposes: state => () => {
        return state.mappings.loanPurposes
    },
    errorPageVisible: state => {
        return state.data.showErrorPage
    },
    loanRange: state => {
        return state.data.loan_range
    },
    generalLoaderVisible: state => {
        return state.data.showGeneralLoader
    },
}

export { getters, mutations, actions }
